import React from 'react';
import Logo from '../../components/Logo';

export const LandingFooter = ({ t }) => (
      <footer className="bg-gray-900 text-gray-300 py-16 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <Logo size="md" />
                <div>
                  <h3 className="font-heading text-xl font-bold text-white">MedRahi</h3>
                  <p className="text-xs text-gray-400">{t('landing.healthcareWithoutBorders')}</p>
                </div>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed">
                {t('landing.footerDesc')}
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold text-white mb-4">{t('landing.quickLinks')}</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#features" className="hover:text-orange-400 transition-colors">{t('landing.whyChoose')}</a></li>
                <li><a href="#how-it-works" className="hover:text-orange-400 transition-colors">{t('landing.yourJourney')}</a></li>
                <li><a href="#doctors" className="hover:text-orange-400 transition-colors">{t('landing.forDoctors')}</a></li>
                <li><a href="#hospitals" className="hover:text-orange-400 transition-colors">{t('landing.forHospitals')}</a></li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-semibold text-white mb-4">{t('landing.popularSpecializations')}</h4>
              <ul className="space-y-2 text-sm">
                <li>{t('landing.specializations.cardiology')}</li>
                <li>{t('landing.specializations.orthopedics')}</li>
                <li>{t('landing.specializations.oncology')}</li>
                <li>{t('landing.specializations.fertility')}</li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-semibold text-white mb-4">{t('landing.contactUs')}</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-center gap-2">
                  <span>📧</span>
                  <span>support@medrahi.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <span>📞</span>
                  <span>+91 98765 43210</span>
                </li>
                <li className="flex items-center gap-2">
                  <span>🇮🇳</span>
                  <span>Mumbai, India</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              {t('landing.copyright')}
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-orange-400 transition-colors">{t('landing.privacyPolicy')}</a>
              <a href="#" className="hover:text-orange-400 transition-colors">{t('landing.termsOfService')}</a>
              <a href="#" className="hover:text-orange-400 transition-colors">{t('landing.cookiePolicy')}</a>
            </div>
          </div>
        </div>
      </footer>
);
